<template>
  <div class="container-fluid mx-0 px-0">
    <div class="container-fluid px-0 mx-0 bg-darkblue d-block d-xl-none w-100">
      <a
        @click="showCollapse = !showCollapse"
        class="container-fluid mx-0 px-0"
      >
        <div class="text-on-img text-center container-fluid mx-0 px-0">
          <img
            src="../assets/images/bg_s-100.jpg"
            alt="桂运宝大宗货运场景"
            width="1200"
            height="675"
            class="img_cannot_download img-fluid mx-0 w-100"
          />
          <div class="caption text-white">
            <p>点击切换详细/缩略模式</p>
            <p class="h4">定制大宗货物运输智能解决方案</p>
            <p class="h4">数智底座赋能华南 华东 西南智能转升级</p>
          </div>
        </div>
      </a>
      <div>
        <div class="mycontainer overflow-auto">
          <my-carousel
            v-show="showCollapse"
            myID="mdCarousel"
            class="mycarousel-md"
          />
        </div>
      </div>
    </div>
    <div class="container-fluid bg-mypics d-none d-xl-block">
      <my-carousel myID="xlCarousel" class="mycarousel-xl" />
      <p class="text-white ms-4 my-4 h2">定制大宗货物运输智能解决方案</p>
      <p class="text-white ms-4 h2">数智底座赋能华南 华东 西南智能转升级</p>
    </div>
  </div>
</template>

<script>
import myCarousel from "@/components/myCarousel.vue";

/**
 * 首页首屏。公司定义段放在行业认可与合作方之间，见 App.vue。
 */
export default {
  name: "Home",
  components: {
    myCarousel,
  },
  data: function () {
    return {
      showCollapse: true,
    };
  },
};
</script>
<style>
.text-on-img {
  position: relative;
}

.caption {
  position: absolute;
  top: 45%;
  left: 0;
  width: 100%;
}

.bg-darkblue {
  background-color: #023047;
}

.bg-mypics {
  background-image: linear-gradient(
      to bottom,
      rgba(33, 158, 188, 0) 90%,
      rgba(0, 147, 188, 1) 99%
    ),
    url(../assets/images/bg-100v2.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  width: 100vw;
  height: 100vh;
}

.mycarousel-xl {
  width: 38vw;
}

.mycarousel-md {
  width: 100vw;
}
</style>
